/**
 * cookieExists
 * @description Checks to see if a cookie exists in the dealer site context
 * @param {String} name - the name of the cookie
 * @return {Boolean} whether or not this cookie was defined on this dealer site
 */
export function cookieExists(name) {
  const nameEquals = `${name}=`
  return !!document.cookie
    .split('; ')
    .find(cookieNameValCur => cookieNameValCur.indexOf(nameEquals) === 0)
}

/**
 * readCookie
 * @description Reads a cookie from the dealer site context
 * @param {String} name - the name of the cookie
 * @return {String} the value of the cookie (or undefined, if not exist)
 */
export function readCookie(name) {
  if (name === '') {
    return undefined
  }
  const nameEquals = `${name}=`
  return document.cookie
    .split('; ')
    .reduce(
      (ret, cookieNameValCur) =>
        cookieNameValCur.indexOf(nameEquals) === 0
          ? decodeURI(cookieNameValCur.substr(nameEquals.length))
          : ret,
      undefined
    )
}

/**
 * setCookie
 * @description Sets a cookie in the dealer site context
 * @param {Object} config - details on the cookie, including name, value, domain, and ttl (in seconds)
 */
export function setCookie({ name, value, ttl, domain, decode = true }) {
  const cookieNameVal = decode
    ? `${name}=${decodeURI(value)}`
    : `${name}=${value}`

  let cookieExpiry = ''
  if (ttl) {
    const expireTime = new Date()
    expireTime.setTime(expireTime.getTime() + ttl * 1000)
    cookieExpiry = `; expires=${expireTime.toGMTString()};`
  }

  let domainString = ''
  if (domain) {
    domainString = `domain=${domain};`
  }

  document.cookie = `${cookieNameVal}${cookieExpiry}; path=/; ${domainString}`
}
